// Lightweight GA4 event helper. Safe no-op when gtag isn't loaded
// (e.g. before cookie consent or in tests/SSR).

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function trackEvent(event: string, params: Record<string, unknown> = {}) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', event, params);
  }
}

/** Outbound click to an external domain (GA4 recommended `click` event shape). */
export function trackOutbound(url: string, location: string) {
  trackEvent('click', {
    link_url: url,
    link_domain: (() => {
      try {
        return new URL(url).hostname;
      } catch {
        return undefined;
      }
    })(),
    outbound: true,
    link_location: location,
  });
}

/**
 * SPA page view. GA4 auto-tracks only the initial load, so both the
 * bootstrap configs use `send_page_view: false` and every view
 * (including the first) is sent from here on route change.
 */
export function trackPageView(params: {
  path: string;
  title?: string;
  language?: string;
}) {
  const location =
    typeof window !== 'undefined' ? window.location.origin + params.path : params.path;
  trackEvent('page_view', {
    page_path: params.path,
    page_location: location,
    page_title: params.title ?? (typeof document !== 'undefined' ? document.title : undefined),
    ...(params.language ? { language: params.language } : {}),
  });
}
